/* Convert theme and options-app icon glyphs to the same SVG stroke system.
   Customer reviews, captions, entered artwork notes and code remain verbatim. */
(() => {
  const paths = {"right":"M4 12h16m-6-6 6 6-6 6","left":"M20 12H4m6-6-6 6 6 6","up":"M12 20V4m-6 6 6-6 6 6","down":"M12 4v16m-6-6 6 6 6-6","external":"M6 18 18 6M6 6h12v12","check":"m5 12 4 4L19 6","close":"m6 6 12 12M6 18 18 6","star":"m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z","shield":"M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6ZM8 12l3 3 5-6","pen":"m14 4 6 6-10 10H4v-6L14 4Zm-7 9 4 4","clock":"M12 8v5l3 2M9 2h6M12 2v3M18 5l2 2","heart":"M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z","bolt":"m13 2-9 12h7l-1 8 10-12h-7Z","warning":"m12 3 10 18H2L12 3ZM12 9v5m0 3h.01","upload":"M12 16V3m-5 5 5-5 5 5M4 16v5h16v-5","truck":"M2 5h12v12H2ZM14 9h4l4 5v3h-8","box":"m3 7 9-4 9 4-9 4-9-4Zm0 0v10l9 4 9-4V7M12 11v10"};
  const icons = {"→":"right","←":"left","↑":"up","⬆":"up","↓":"down","↗":"external","✓":"check","✔":"check","✅":"check","×":"close","✕":"close","★":"star","⭐":"star","🛡":"shield","🎨":"pen","⏱":"clock","⏰":"clock","🖤":"heart","❤":"heart","⚡":"bolt","⚠":"warning","🚧":"warning","📤":"upload","📦":"box","🚚":"truck"};
  const pattern = /[→←↑⬆↓↗✓✔✅×✕★⭐🛡🎨⏱⏰🖤❤⚡⚠🚧📤📦🚚]\uFE0F?/gu;
  const skip = 'script,style,svg,textarea,input,option,pre,code,[contenteditable],#looxReviews,.loox-review,.testimonial__text,[data-view-caption],.pp-photo-wall__tile > span';
  function replace(node) {
    if (!node.parentElement || node.parentElement.closest(skip)) return;
    const text = node.nodeValue;
    pattern.lastIndex = 0;
    if (!pattern.test(text)) return;
    pattern.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let end = 0;
    for (const match of text.matchAll(pattern)) {
      fragment.append(text.slice(end, match.index));
      const key = icons[match[0].replace('\uFE0F','')];
      if (key === 'close' && text.trim() !== match[0]) { fragment.append(match[0]); end=match.index+match[0].length; continue; }
      const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('viewBox','0 0 24 24');
      svg.setAttribute('class','pp-ui-icon');
      svg.setAttribute('aria-hidden','true');
      svg.setAttribute('focusable','false');
      const path = document.createElementNS(svg.namespaceURI,'path');
      path.setAttribute('d',paths[key]);
      if (key === 'star') svg.setAttribute('fill','currentColor');
      svg.append(path);
      if (key === 'clock') { const circle=document.createElementNS(svg.namespaceURI,'circle'); circle.setAttribute('cx','12');circle.setAttribute('cy','13');circle.setAttribute('r','8');svg.prepend(circle); }
      fragment.append(svg);
      end = match.index + match[0].length;
    }
    fragment.append(text.slice(end));
    node.replaceWith(fragment);
  }
  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) return replace(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(skip)) return;
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replace);
  }
  scan(document.body);
  new MutationObserver(records => {
    for(const record of records) {
      if(record.type === 'characterData') replace(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body,{childList:true,subtree:true,characterData:true});
})();
